import { render, staticRenderFns } from "./activity-statistics.vue?vue&type=template&id=fa4c44e4&scoped=true&"
import script from "./activity-statistics.vue?vue&type=script&lang=js&"
export * from "./activity-statistics.vue?vue&type=script&lang=js&"
import style0 from "./activity-statistics.vue?vue&type=style&index=0&id=fa4c44e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4c44e4",
  null
  
)

export default component.exports